import React from 'react'
import './Stars.css'

const Text = ({text}) => {
  return (
    <div className='txt-containers'>
        {text}
    </div>
  )
}

export default Text